// extracted by mini-css-extract-plugin
export default {"share":"index_share_Xc59u","shareFix":"index_shareFix_79ixG"};